/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconUnderhand: {
  name: 'underhand';
  data: string;
} = {
  name: 'underhand',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M72.804 560.294c135.556 0 141.051-1.832 141.051-1.832C388.689 842.604 527.107 455.99 545.05 316.123l-51.215-.222 100.192-174.898 96.214 174.362-49.828 2.054C525.472 718.479 217.401 736.148 72.804 560.294z" transform="translate(-45.3 -60.361) scale(.90737)"/></svg>`,
};
